import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterSection = ({ 
  currentLanguage, 
  selectedFilter, 
  onFilterChange, 
  selectedCategory, 
  onCategoryChange 
}) => {
  const filterOptions = [
    {
      id: 'all',
      label: currentLanguage === 'en' ? 'All Areas' : 'Maeneo Yote',
      icon: 'Grid3X3'
    },
    {
      id: 'corporate',
      label: currentLanguage === 'en' ? 'Corporate' : 'Makampuni',
      icon: 'Building2'
    },
    {
      id: 'individual',
      label: currentLanguage === 'en' ? 'Individual' : 'Binafsi',
      icon: 'User'
    },
    {
      id: 'litigation',
      label: currentLanguage === 'en' ? 'Litigation' : 'Mahakama',
      icon: 'Scale'
    }
  ];

  const categoryOptions = [
    {
      id: 'all',
      label: currentLanguage === 'en' ? 'All Complexity' : 'Ugumu Wote'
    },
    {
      id: 'basic',
      label: currentLanguage === 'en' ? 'Basic' : 'Msingi'
    },
    {
      id: 'intermediate',
      label: currentLanguage === 'en' ? 'Intermediate' : 'Kati'
    },
    {
      id: 'complex',
      label: currentLanguage === 'en' ? 'Complex' : 'Ngumu'
    }
  ];

  return (
    <div className="bg-white rounded-lg border border-border p-6 mb-8">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-6">
          <div className="flex items-center space-x-2">
            <Icon name="Filter" size={20} className="text-text-secondary" />
            <span className="font-medium text-text-primary">
              {currentLanguage === 'en' ? 'Filter by:' : 'Chuja kwa:'}
            </span>
          </div>
          
          <div className="flex flex-wrap gap-2">
            {filterOptions.map((option) => (
              <Button
                key={option.id}
                variant={selectedFilter === option.id ? 'primary' : 'ghost'}
                size="sm"
                iconName={option.icon}
                iconPosition="left"
                onClick={() => onFilterChange(option.id)}
                className="text-xs"
              >
                {option.label}
              </Button>
            ))}
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <span className="text-sm text-text-secondary font-caption">
            {currentLanguage === 'en' ? 'Complexity:' : 'Ugumu:'}
          </span>
          <select
            value={selectedCategory}
            onChange={(e) => onCategoryChange(e.target.value)}
            className="px-3 py-1 border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            {categoryOptions.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterSection;